import { combineReducers } from 'redux'
import DefaultReducers from 'reducers'
import SearchProviderReducer from 'reducers/searchProvider'
const Reducer = combineReducers({
  ...DefaultReducers,
  searchProvider: SearchProviderReducer,
})
export default Reducer
